export const ACCESS_MODULES = {
  "Resource-library": 1,
  Workshops: 2,
  Events: 3,
};
